import request from '../request'

/**
 * 获取菜单树（嵌套结构）。
 * @returns {Promise<Array>} 菜单树数组
 */
export function fetchMenuTree() {
  return request({
    url: '/api/menu/list',
    method: 'GET',
  })
}

/**
 * 获取扁平菜单列表。
 * @returns {Promise<Array>} 扁平菜单数组
 */
export function fetchFlatMenuList() {
  return request({
    url: '/api/menu/flat-list',
    method: 'GET',
  })
}

/**
 * 更新菜单。
 * @param {string|number} menuId 菜单 ID。
 * @param {Object} payload 更新数据（title, path, sort, componentPath, icon 等）。
 * @returns {Promise}
 */
export function updateMenu(menuId, payload) {
  return request({
    url: `/api/menu/update/${menuId}`,
    method: 'PUT',
    data: payload,
  })
}

/**
 * 删除菜单。
 * @param {string|number} menuId 菜单 ID。
 * @returns {Promise}
 */
export function deleteMenu(menuId) {
  return request({
    url: `/api/menu/delete/${menuId}`,
    method: 'DELETE',
  })
}
